
import React, { useEffect, useState } from "react";

const AnimatedLoaderText = ({ interval = 6500 }) => {
  const loaderMessages = [
  "Hang tight…",
  "this one’s a bit heavy",
  "might take a moment.",
];  
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIdx((prev) => (prev + 1) % loaderMessages.length);
    }, interval);
    return () => clearInterval(timer);
  }, [interval]);

  return (
    <div className="mt-2 text-center text-sm text-gray-600 font-medium animate-pulse" style={{ minHeight: 24 }}>
      {loaderMessages[idx]}
    </div>
  );
}

export default AnimatedLoaderText;
